export enum StorageKeys {
  SITE_ID = 'siteId',
  PAYMENT_USER_EMAIL = 'paymentUserEmail',
  GOOGLE_APPOINTMENT_BID = 'google-appointment-bid',
  GOOGLE_APPOINTMENT_TOKEN = 'google-appointment-token',
  GOOGLE_APPOINTMENT_TOKEN_CONSUMED = 'google-appointment-token-consumed',
  FROM_NEARBY_CLICK = 'from-nearby-click',
}

export const { SITE_ID, PAYMENT_USER_EMAIL } = StorageKeys
